<template>
  <article v-if="user">
    <div class="mt-2 mb-4 border-bottom">
      <h2 class="display-4">Dein Konto</h2>
    </div>
    <div class="mb-3">
      <label for="username" class="form-label">{{
        $store.state.language.username
      }}</label>
      <input
        type="text"
        class="form-control disabled"
        id="username"
        aria-describedby="emailHelp"
        :placeholder="user.username"
        disabled
      />
    </div>

    <div class="mb-3">
      <label for="firstname" class="form-label">Vorname</label>
      <input
        type="text"
        class="form-control"
        id="firstname"
        aria-describedby="emailHelp"
        v-model="user.firstname"
      />
    </div>
    <div class="mb-3">
      <label for="lastname" class="form-label">Nachname</label>
      <input
        type="text"
        class="form-control"
        id="lastname"
        aria-describedby="emailHelp"
        v-model="user.lastname"
      />
    </div>

    <hr />

    <button
      v-if="firstnameIsCorrect && lastnameIsCorrect && isChanged"
      @click="submit"
      class="btn btn-primary"
    >
      <span>Speichern</span>
    </button>
    <button v-else class="btn btn-outline-primary disabled" disabled>
      <span>Speichern</span>
    </button>
  </article>
</template>

<script>
export default {
  name: "Setting",

  props: {
    user: Object,
  },

  data() {
    return {
      firstnameIsCorrect: true,
      lastnameIsCorrect: true,
      isChanged: false,
    };
  },

  mounted() {
    this.$nextTick(() => {
      this.oldData = JSON.parse(
        JSON.stringify(this.$store.state.modules.account.user)
      );
    });
  },

  watch: {
    "user.firstname"() {
      const val = this.$store.state.utils.filters.name(this.user.firstname);
      this.isChanged = true;
      this.firstnameIsCorrect = val.has_minimum_lenth && val.only_letters;
    },
    "user.lastname"() {
      const val = this.$store.state.utils.filters.name(this.user.lastname);
      this.isChanged = true;

      this.lastnameIsCorrect = val.has_minimum_lenth && val.only_letters;
    },
  },

  methods: {
    submit() {
      event.preventDefault();
      if (this.firstnameIsCorrect && this.lastnameIsCorrect) {
        this.$store.state.utils.processing = true;
        let data = {
          firstname: this.user.firstname,
          lastname: this.user.lastname,
        };

        this.$store.state.modules.api
          .updateProfile(data, JSON.parse(localStorage.account).token)
          .then((resp) => {
            if (resp.status == 200) {
              this.$store.state.utils.setNewNotifications(
                {
                  type: "success",
                  message: "Success uploaded your setting",
                },
                2500
              );
              this.$router.push({ name: "CPanel" });
            } else {
              this.$store.state.utils.setNewNotifications(
                {
                  type: "warning",
                  title: "Fehlermeldung",
                  message: "Etwas ist schief gelaufen. :(",
                },
                2500
              );
            }
            this.$store.state.utils.processing = false;
          })
          .catch((err) => {
            console.error(err);
          });
      } else {
        this.$store.state.utils.setNewNotifications(
          {
            type: "hint",
            message: "Check the entries are correct",
          },
          2500
        );
        this.user = this.oldData;

        this.$store.state.utils.processing = false;
      }
    },
  },
};
</script>
